import { createFileRoute } from '@tanstack/react-router';
import { PeopleListBody } from '@/components/people/PeopleListBody';
import { parsePeopleSearch } from '@/components/people/people-filters';

// Divisible by every grid width (3-col desktop, 2-col tablet, 1-col
// mobile) so each loaded page keeps the card rows complete — 25 left a
// lone card on the last row after every "Load more".
const PEOPLE_PAGE_SIZE = 24;

export const Route = createFileRoute('/_authed/people/')({
  validateSearch: parsePeopleSearch,
  component: PeoplePage,
});

function PeoplePage() {
  return <PeopleListBody pageSize={PEOPLE_PAGE_SIZE} />;
}
